// this file handles the front page's slider only.

import Flickity from 'flickity'
// import 'flickity/dist/flickity.min.css'
import 'flickity-imagesloaded'

export function activateHomeSlider () {
  const homeSlider = document.querySelector('.region--front-slider')
  const slides = document.querySelectorAll('.home-page-slide')

  if (homeSlider && slides.length > 0) {
    setupCarousel(homeSlider)
  }
}

function setupCarousel (element) {
  const options = {
    cellAlign: 'center',
    imagesLoaded: true,
    contain: true,
    autoPlay: 8000,
    wrapAround: true,
    prevNextButtons: true,
    pauseAutoPlayOnHover: false,
    cellSelector: '.home-page-slide',
    adaptiveHeight: true,
    pageDots: false
  }

  const instance = new Flickity(element, options)

  // console.log({ instance })
}
